<div class="back">
  <div class="p-grid p-justify-between p-align-center">
    <div *ngFor="let m of menus" class="p-col">
      <app-menu-button [menu]="m"> </app-menu-button>
    </div>
  </div>
</div>
